import React from "react";
import furgone3_5t from '../../../assets/images/icons/furgone3_5t.svg';
import motrice7_5t from '../../../assets/images/icons/motrice7_5t.svg';
import motrice7_5t2 from '../../../assets/images/icons/motrice7_5t2.svg';
import centinatoMega from '../../../assets/images/icons/centinatoMega.svg';
import centinatoStandard from '../../../assets/images/icons/centinatoStandard.svg';
import frigo from '../../../assets/images/icons/frigo.svg';
import portaCoil from '../../../assets/images/icons/portaCoil.svg';
import trattoreStandard from '../../../assets/images/icons/trattoreStandard.svg';
import furgonato from '../../../assets/images/icons/furgonato.svg';
import trattoreTreAssi from '../../../assets/images/icons/trattoreTreAssi.svg';
import trattoreMega from '../../../assets/images/icons/trattoreMega.svg';
import { useTranslation } from "react-i18next";
import ErrorIcon from '@mui/icons-material/Error';
import { ErrorOutlineOutlined, ErrorOutlineRounded, ErrorRounded, ErrorTwoTone } from "@mui/icons-material";
import { Typography } from '@mui/material';

type VehicleData = {
  licensePlate: string;
  firstRegistrationDate: string | null;
  environmentClass: string | null;
  fuelType: string | null;
  emissionsData: number;
  status: string;
  lastTraceabilityCheck: string;
  category: string; // Nuova struttura dati
  mainCategory: string; // Nuova struttura dati
};

interface VehiclesProps {
  vehicles: VehicleData[]; // Ora è un array invece di un oggetto annidato
  handleOpen: (data: { type: string; name: string; vehicles: VehicleData[] }) => void;
}


export const VehiclesGrid: React.FC<VehiclesProps> = ({ vehicles, handleOpen }) => {
  const { t } = useTranslation();

  const subCategoryIcons: { [key: string]: string } = {
    "3.5 ton van": furgone3_5t, 
    "Mega Truck": trattoreMega, 
    "Over 7.5 ton truck": motrice7_5t2, 
    "Standard Truck": trattoreStandard, 
    "Three axles truck": trattoreTreAssi, 
    "Up to 7.5 ton truck": motrice7_5t, 
    "INCOMPLETE":furgone3_5t,
    "Box": furgonato, 
    "Coil trailer": portaCoil, 
    "Frigo": frigo, 
    "Mega tautliner": centinatoMega,  
    "Standard tautliner": centinatoStandard,  
    "Container trailer": portaCoil,
  };

  // Raggruppa i veicoli per categoria e sottocategoria
  const groupedVehicles = (Array.isArray(vehicles) ? vehicles : []).reduce((acc, vehicle) => {
    if (!vehicle ) {
      return acc; 
    }
    if (!acc[vehicle.mainCategory]) {
      acc[vehicle.mainCategory] = {};
    }
    if (!acc[vehicle.mainCategory][vehicle.category]) {
      acc[vehicle.mainCategory][vehicle.category] = [];
    }
    acc[vehicle.mainCategory][vehicle.category].push(vehicle);
    return acc;
  }, {} as Record<string, Record<string, VehicleData[]>>);

  // Trasforma in array per il rendering
  const categories = Object.entries(groupedVehicles).flatMap(([category, subCategories]) =>
    Object.entries(subCategories).map(([subCategory, vehicleList]) => ({
      type: category,
      name: subCategory,
      quantity: vehicleList.length,
      vehicles: vehicleList,
    }))
  );

  

  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      {categories.length > 0 ? (
        <div style={{ width: "100%" }}>
          {categories.map((vehicle, index) => {
            return(
            <div
              key={index}
              className={`bg-lightGrey shadow-card p-[20px] flex items-center justify-between cursor-pointer ${
                index !== categories.length - 1 ? "mb-6" : ""
              }`}
              onClick={() => handleOpen({ type: vehicle.type, name: vehicle.name, vehicles: vehicle.vehicles })}
            >
              <div>
                <div className="uppercase text-red leading-[17px] text-sm font-semibold mb-2">
                  {vehicle.type === "Vehicle"
                    ? t("screens.dashboard.widgets.registeredFleet.vehicles")
                    : t("screens.dashboard.widgets.registeredFleet.trailers")}
                </div>
                <div className="text-[18px] font-bold leading-[21px]"> {t(`screens.fleetAndRoute.vehicles.${vehicle.name}`, vehicle.name)}</div>
              </div>
              <div className="flex items-center">
                <div className="text-2xl font-bold leading-[29px] mr-4" style={{ color: "#CF0A2C" }}>
                  {vehicle.quantity}
                </div>
                <div className="relative">
                  <img src={subCategoryIcons[vehicle.name] || furgonato} alt={vehicle.name} />
                  {vehicle.name === "INCOMPLETE" && (
                    <div style={{ width: '15px', height: '15px', backgroundColor:'#CF0A2C', borderRadius:'50%' , position:'absolute', bottom:14, right:-4, display:'flex', alignItems:'center', justifyContent:'center'}}>
                      <Typography  style={{ color: 'white', fontWeight: 'bold', lineHeight: 1, fontSize:'10px' }}>!</Typography>
                    </div>
                  )}
                </div>
              </div>
            </div>
)})}
        </div>
      ) : (
        <div className="col-span-12 md:col-span-6">Nessun veicolo disponibile</div>
      )}
    </div>
  );
};
